var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrash = function SvgTrash(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M8 2.992h3.008V4H10v8.992L9.008 14H2l-.992-1.008V4H0V2.992h3.008V2q0-.416.288-.704A.93.93 0 0 1 4 .992h3.008q.4.016.688.304A.93.93 0 0 1 8 2zM7.008 2H4v.992h3.008zM2 12.992h7.008V4H2zm2-8h-.992V12H4zm1.008 0H6V12h-.992zm2 0H8V12h-.992z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };